<template>
        <div>
                <el-tag
                        v-show="!disabled"
                        style="margin-right: 10px;"
                        v-for="(item, i) in outShowTimes"
                        :key="i"
                        closable
                        size="medium"
                        @close="handleClose(i,'out')"
                >
                        {{ item }}
                </el-tag>
                <el-tag
                        v-show="disabled"
                        size="medium"
                        style="margin-right: 10px;"
                        v-for="(item, i) in outShowTimes"
                        :key="i"
                >
                        {{ item }}
                </el-tag>
                <el-tag  type="danger" size="medium" v-show="!disabled" @click="openDialog">+</el-tag>
                <el-dialog
                       
                        width="60%"
                        
                        :bottom="0"
                        append-to-body
                        id="select-time-box20211013"
                        style="max-hight:100vh;margin-bottom:0"
                        :fullscreen="dialogFull"
                        :close-on-click-modal="false"
                        :visible.sync="dialogVisible"
                        :destroy-on-close="true"
                        
                        v-loading="loading"

                >
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        时间段选择
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                                
                        </div>
                </template>
                <div class="body">
                        <el-form ref="form" v-model="form">
                                <el-row>
                                        <el-col span="24">
                                                <el-form-item label="选择时段">
                                                        <el-time-picker
                                                                v-model="form.startTime"
                                                                
                                                                style="width:135px;"
                                                                :picker-options="{
                                                                        selectableRange: '00:00:00 - 23:59:59',
                                                                        format:'HH:mm'
                                                                }"
                                                                format="HH:mm"
                                                                placeholder="请选择开始时间">
                                                        </el-time-picker>
                                                        <span style="margin:0 15px;">至</span>
                                                        <el-select v-model="form.type" style="width:90px;">
                                                                <el-option label="今日" value="1"></el-option>
                                                                <el-option label="次日" value="2"></el-option>
                                                                <el-option label="其他" value="99"></el-option>
                                                        </el-select>
                                                        <el-input v-show="showDaysFlag" type="number" maxlength="8" @input="daysInput" :max="8" v-model="form.days" style="width:90px;margin:0 15px;">
                                                                
                                                        </el-input>
                                                        <span v-show="showDaysFlag">
                                                                天后
                                                        </span>
                                                        <el-time-picker
                                                                v-model="form.endTime"
                                                                
                                                                style="width:135px;margin:0 15px;"
                                                                :picker-options="{
                                                                        selectableRange: '00:00:00 - 23:59:59',
                                                                        format:'HH:mm'
                                                                }"
                                                                format="HH:mm"
                                                                placeholder="请选择结束时间">
                                                        </el-time-picker>
                                                        <el-button size="small" @click="addTime">添加</el-button>
                                                </el-form-item>
                                        </el-col>
                                </el-row>
                                 <el-row>
                                        <el-col span="24">
                                                <el-form-item label="已选时段">
                                                       <el-tag
                                                                v-show="!disabled"
                                                                style="margin-right: 10px;"
                                                                v-for="(item, i) in showTimes"
                                                                :key="i+100"
                                                                closable
                                                                size="medium"
                                                                @close="handleClose(i)"
                                                        >
                                                                {{ item }}
                                                        </el-tag>
                                                        
                                                </el-form-item>
                                        </el-col>
                                </el-row>
                                
                        </el-form>
                </div>
                <template slot="footer">
                        <div style="display:flex;justify-content:center;">
                                <el-button type="primary" @click="save">保存</el-button>
                                <el-button type="success" @click="cancel">取消</el-button>
                        </div>
                </template>
                </el-dialog>
     
        </div>
</template>

<script>

export default {
        props:{
                disabled:{
                        type:Boolean,
                        default:false
                },
                value:{
                        type:String,
                        default:''
                }
        },
        data() {
                return {
                        showDaysFlag:false,
                        dialogVisible:false,
                        dialogFull:false,
                        form: {
                                type:'1',
                                days:"0",

                                startTime: '',
                                endTime: '',
                                
                        },
                        showTimes:[],
                        outShowTimes:[],
                        selectTimes:[],
                        
                };
        },
        watch: {
                "form.type"(){
                       this.paramChange(); 
                },
                "value"(val){
                        if(val.length==0){
                                this.showTimes = [];
                                this.outShowTimes = [];
                        }else{
                                this.showTimes = val.split(",");
                                this.outShowTimes = val.split(",");
                        }
                        
                }
               
        },
        methods: {
                // 控制天只能大于等于0得整数
                daysInput(e){
                        console.log(e)
                       
                        if(e!=''&&e!='e'){
                                if(parseInt(e)>99999999){
                                        this.form.days = 99999999;
                                }else{
                                        this.form.days = parseInt(e);
                                }
                                
                        }else{
                                this.form.days = 0;
                        }
                        
                },
                // 表单数据变动监听
                paramChange(){
                        if(this.form.type==99){
                                this.showDaysFlag = true;
                                this.form.days = 2;
                        }else if(this.form.type==2){
                                this.form.days = 1;
                                this.showDaysFlag = false;
                        }else{
                                this.form.days = 0;
                                this.showDaysFlag = false;
                        }
                },
                // 增加时间段
                addTime(){      
                        let timeObj = {};
                        
                         if(this.form.days !=="" && this.form.startTime && this.form.endTime){
                                 if(this.form.days==0){
                                        let startTime = parseInt(this.dayjs(this.form.startTime).format('HHmm'));
                                        let endTime = parseInt(this.dayjs(this.form.endTime).format('HHmm'));
                                        if(startTime>endTime){
                                                this.$message({
                                                        message: '开始时间不能大于结束时间！',
                                                        type: 'warning'
                                                });
                                                return;
                                        }
                                }
                                timeObj = JSON.parse(JSON.stringify(this.form));
                                timeObj.startTime = this.dayjs(timeObj.startTime).format('HH:mm');
                                timeObj.endTime = this.dayjs(timeObj.endTime).format('HH:mm');
                                
                                        timeObj.time = timeObj.startTime + "~" + timeObj.endTime;
                                        if(timeObj.days>0){
                                                timeObj.time += "+" + timeObj.days + "天";
                                        }
                                        

                                        if(this.showTimes.indexOf(timeObj.time) > -1){

                                                this.$confirm('已经存在与该时间段相同的时间段，是否还要继续添加？', '提示', {
                                                        confirmButtonText: '确定',
                                                        cancelButtonText: '取消',
                                                        type: 'warning'
                                                }).then(() => {
                                                        this.selectTimes.push(timeObj);
                                                        this.showTimes.push(timeObj.time);
                                                }).catch(()=>{
                                                        return;
                                                })
                                        }else{
                                                this.showTimes.push(timeObj.time);
                                        }

                        }else{
                                this.$message({
                                        message: '请填写一条完整得时间段再点击添加！',
                                        type: 'warning'
                                });
                        }
                },
                // 取消
                cancel(){
                        this.dialogVisible = false;

                },
                // 保存
                save(){
                        let value = this.showTimes.join(",");
                        this.$emit("update:value",value);
                        this.dialogVisible = false;
                        // this.value = 
                },
                // 删除已选择时间段
                handleClose(i,type){
                        if(type=="out"){
                                this.outShowTimes.splice(i, 1);
                        }
                        this.showTimes.splice(i, 1);
                        // this.selectTimes.slice(i,1)
                },
                // 打开弹窗
                openDialog(){
                        let outShowTimes = this.outShowTimes.join(",");
                        console.log(outShowTimes.length)
                        if(outShowTimes.length==0){
                                this.showTimes = [];
                        }else{
                                this.showTimes = outShowTimes.split(",");
                        }
                        
                        console.log(this.showTimes)
                        this.dialogVisible = true;
                }
        },
};
</script>

<style lang="scss" >
        #select-time-box20211013{
                .el-input__icon{
                        line-height: 32px;
                }
                .avue-dialog__footer{
                        display: flex;
                        justify-content:flex-end;
                }
        }
        
</style>
